import StereoBaseActionHelper from '../-private/helpers/action-helper';
import { didCancel } from 'ember-concurrency';
/**
  A helper to load a sound
  ```hbs
    <button {{on 'click' (play-sound @identifier}}>
      Play
    </button>
  ```
  @class {{play-sound}}
  @type {Helper}
  @param {String} url
  @param {Object} options
  @param {Object} metadata
  */

/**
  @method compute
  @param {Any} identifier a url, an array of urls, a url object, a Sound, or a promise resolving to any of those
  @param {Hash} metadata? metadata that should be included with the sound
  @param {[String]} useConnections? array of connection names in preference order
  @param {[String]} xhr? hash of xhr options: { method: 'POST', headers: { Authorization: 'Bearer 1234'}, withCredentials: true }
  @return {Function}
*/
export default class playSound extends StereoBaseActionHelper {
  performAction() {
    return this.stereo.playTask
      .perform(this.identifier, this.options)
      .catch((e) => {
        if (!didCancel(e)) {
          throw e;
        }
      });
  }
}
